import React from "react";
import { Modal } from "react-bootstrap";
import { useTheme } from "../../../context/ThemeProvider";
import styles from "./ConfirmNotSfwModal.module.css";
import globalStyles from "../../../styles/globalStyles.module.css";
import { useTranslation } from "react-i18next";

// Define the props type for the modal
interface confirmNotSfwModalProps {
  isOpen: boolean;
  onClose: () => void;
  setIsNsfw: (isNsfw: boolean) => void;
}

const AddBoosterToStoreModal: React.FC<confirmNotSfwModalProps> = ({
  isOpen,
  onClose,
  setIsNsfw,
}) => {
  const { currentTheme } = useTheme();
  const { t } = useTranslation();

  const handleCloseModal = () => {
    onClose();
  };

  const handleOverrideNsfw = () => {
    setIsNsfw(false);
    onClose();
  };

  return (
    <Modal
      show={isOpen}
      onHide={handleCloseModal}
      size="xl"
      className={`${currentTheme} d-flex`}
    >
      <div className={styles.container}>
        <button onClick={onClose} className={globalStyles.button}>
          <h4> {t("cancel")}</h4>
        </button>
        <button onClick={handleOverrideNsfw} className={globalStyles.button}>
          <h4> {t("confirm")}</h4>
        </button>
      </div>
    </Modal>
  );
};

export default AddBoosterToStoreModal;
